import * as actionTypes from '../consts/actionTypes';

export function getPracticas() {
    return {
        type: actionTypes.GET_PRACTICAS,
        payload: ''
    };
}